export default __webpack_public_path__ + "static/2-3093b29c6809f83a54b1c12da51fe7ce.jpeg";